var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventManager } from '@or-sdk/event-manager';
import { Discovery } from '@or-sdk/discovery';
import { parseAxiosError } from '@or-sdk/base';
export class Providers {
    constructor(params) {
        this._providersAccountId = undefined;
        this._eventManagerUrl = undefined;
        const { token, discoveryUrl, eventManagerUrl, providersAccountId } = params;
        if (!(eventManagerUrl && providersAccountId) && !discoveryUrl) {
            throw new Error('Providers require Discovery URL or both Event Manager URL and Providers Account ID.');
        }
        this.eventManager = new EventManager({
            token,
            discoveryUrl,
            eventManagerUrl,
        });
        this.discovery = new Discovery({
            token,
            discoveryUrl,
        });
        this._eventManagerUrl = eventManagerUrl;
        this._providersAccountId = providersAccountId;
    }
    get providersAccountId() {
        return this._providersAccountId;
    }
    get eventManagerUrl() {
        return this._eventManagerUrl;
    }
    get providersUrl() {
        return this.providersAccountId ? `/http/${this.providersAccountId}` : '';
    }
    makeRequest(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const fullUrl = yield this.generatePath(params.route);
                return yield this.eventManager.makeRequest(Object.assign(Object.assign({}, params), { route: fullUrl }));
            }
            catch (error) {
                throw this.parseError(error);
            }
        });
    }
    getGatewayUrl(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return `${this.eventManagerUrl}${yield this.generatePath(path)}`;
        });
    }
    fetchProvidersAccountId() {
        return __awaiter(this, void 0, void 0, function* () {
            this._providersAccountId = yield this.discovery.getProvidersAccountId();
        });
    }
    generatePath(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.providersAccountId) {
                yield this.fetchProvidersAccountId();
            }
            return `${this.providersUrl}/${path}`;
        });
    }
    parseError(error) {
        return parseAxiosError(error);
    }
}
//# sourceMappingURL=Providers.js.map